import { render, staticRenderFns } from "./LadingPage.vue?vue&type=template&id=0a3d0eee&scoped=true"
import script from "./LadingPage.vue?vue&type=script&lang=js"
export * from "./LadingPage.vue?vue&type=script&lang=js"
import style0 from "./LadingPage.vue?vue&type=style&index=0&id=0a3d0eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d0eee",
  null
  
)

export default component.exports